import { CompositeDecorator, ContentState, EditorState } from 'draft-js';
import Link from '../components/Link';

const decorator = new CompositeDecorator([
  { strategy: findLinks, component: Link },
]);

export const initializeEditor = (initialText) => {
  const normalizedText = initialText?.trim();

  if (normalizedText) {
    const content = ContentState.createFromText(normalizedText);
    const state = EditorState.createWithContent(content, decorator);
    const textLength = normalizedText.length;
    const selection = state
      .getSelection()
      .merge({ anchorOffset: textLength, focusOffset: textLength });
    return EditorState.forceSelection(state, selection);
  }

  return EditorState.createEmpty(decorator);
};

function findLinks(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
}
